//to manage names of components to make code readable
export enum ComponentName {
    clientList,
    userList,
    itemList,
    editUser,
    mainItem
}